export default __webpack_public_path__ + "static/latitude-scam-alert-3-6a861be3aee1c32a689a0a3bbec32fae.webp";